var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPictures = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M8.496 13.088 5.016 17.6h13.968l-4.488-6-3.48 4.488zM21 18.584q0 .816-.6 1.416t-1.416.6H5.016Q4.2 20.6 3.6 20T3 18.584V4.616Q3 3.8 3.6 3.2t1.416-.6h13.968q.816 0 1.416.6t.6 1.416z"
})));
export default SvgPictures;